export const fetchGetVendors = () => ({
  type: 'FETCH_GET_VENDORS',
  payload: {
    client: 'tracking',
    request: {
      method: 'get',
      url: '/get-vendors'
    }
  }
})



// WEBPACK FOOTER //
// ./src/Participant/MyOrders/ProductOrderDetail/ProductSide/actions.js